import React, { useState, useContext, useEffect ,useCallback} from 'react';
import styled from 'styled-components';
import { FiMenu, FiX } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext,siteName } from '../main';
import useLocalStorage from "use-local-storage";
import {
  getDataDB,
  saveDataDB,
  modifyDataModel,
  modifyTextAI,
  countWords,
  isDescriptionField,
  isImageField,
  handleFontAwesomeRedirect
} from "../api";
import moment from "moment";
import EditModal from '../pages/EditModal';


// Styled Components
const Navbar = styled.nav`
  background-color: #000;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1000;

  @media (max-width: 768px) {
    padding: 15px 20px;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;

  img {
    height: 40px;
  }
`;

const MenuLinks = styled.ul`
  display: flex;
  list-style: none;
  gap: 30px;
  margin: 0;
  padding: 0;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    background: #000;
    position: absolute;
    top: 70px;
    right: 0;
    width: 100%;
    padding: 20px 0;
    gap: 20px;
    display: ${props => (props.open ? 'flex' : 'none')};
  }
`;

const NavLink = styled.li`
  a {
    color: #fff;
    text-decoration: none;
    font-weight: 500;
    font-size: 16px;
    transition: color 0.3s;

    &:hover {
      color: #39d353;
    }
  }
`;

const CTAButton = styled.a`
  background: #39d353;
  color: #000;
  padding: 10px 20px;
  border-radius: 30px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
`;

const Hamburger = styled.div`
  display: none;
  font-size: 28px;
  color: #fff;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Nav = (props) => {
  const { handleEditItem, navOptions, navEdit = false } = props;

  const { appState, setAppState } = useContext(AppContext);
 
  const {
    navbars: contextNavbars = {},
    editItemMain = {},
    editMode = false,
    hidden = [],
    payments = {},
    about = {},
    slides = {},
    collections = {},
    reviews = {},
    services = {},
    serviceList = {},
    faqs = {},
    homestatic = {},
    marquees = {},
    pricings = {},
    footers = {},
    banners = {},
    blogsnotitle = {},
    banners2 = {},
    pricelists = {},
    videoanimates = {},
    locations = {},
    populars = {},
    menuas = {},
    menubs = {},
    duplicates = [],
    newBgColor = "#1E1F22",
    newTextColor = "#000000",
    myorder = [
      "navbars",
      "menubs",
      "menuas",
      // "menucs",
      "swiper",
      "serviceList",
      "aboutUs",
      "reviews",
      "collections",
      "help",
      "payment",
      "homestatic",
      "marquees",
      "blogs",
      "pricings",
      "pricelists",
      "videoanimates",
      "locations",
      "populars",
      "banners",
      "banners2",
      "footers",
    ],
    // reviewsHeader,
    // collectionsHeader,
    bannerPointer,
    blog = {},
    industryType = '',
    showServices = false
  } = appState;
  const [navbars, setNavbars] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [myStore, setMyStore] = useLocalStorage("name", {});
  const { myInfo } = myStore || {};
  const [editItem, setEditItem] = useState({});
  const [loading, setLoading] = useState(false);
  const [editHeader, setEditHeader] = useState(false);

  
  const navigate = useNavigate();

  useEffect(() => {
    const incoming = navOptions || contextNavbars;
  
    if (Object.keys(incoming).length && JSON.stringify(incoming) !== JSON.stringify(navbars)) {
      setNavbars(incoming);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navOptions, contextNavbars]);
  


  const handleLogout = () => {
    if (myInfo?.token) {
      const confirmed = window.confirm("Are you sure you want to logout?");
      if (confirmed) {
        setMyStore({});
        setTimeout(() => navigate("/Login"), 200);
      }
    }
  };

    const handleColorChange = useCallback(async (e) => {
      const newColor = e.target.value;
      if (!newColor) {
        return
      }
      appState["newBgColor"] = newColor;
      // alert(appState?.newBgColor)
      delete appState?.navbars;
      delete appState?.section;
      delete appState?.editMode;
      await saveDataDB({
        query: {
          date: moment(),
          config: appState,
          siteName: siteName,
        },
        keys: ["siteName"],
        resource: "vare_sites",
      }).then((info) => {
        // console.log('ccccccc', info)
        setAppState((existing) => {
          return {
            ...existing,
            newBgColor: newColor,
          };
        });
      });
      // Update all elements with bg-dark-1 class
      document.querySelectorAll('.bg-dark-1').forEach(element => {
        element.style.backgroundColor = newColor;
      });
  
      // Update body background
      document.body.style.backgroundColor = newColor;
  
      // Update any elements using the CSS variable
      document.documentElement.style.setProperty('--bg-dark-1', newColor);
    }, [
      appState
    ]);
  
    const handleTextColor = useCallback(async (e) => {
      const newColor = e.target.value;
      if (!newColor) {
        return
      }
      appState["newTextColor"] = newColor;
      delete appState?.section;
      delete appState?.editMode;
      await saveDataDB({
        query: {
          date: moment(),
          config: appState,
          siteName: siteName,
        },
        keys: ["siteName"],
        resource: "vare_sites",
      }).then((info) => {
        setAppState((existing) => {
          return {
            ...existing,
            newTextColor: newColor,
          };
        });
      });
    }, [appState]);

      const handleSave = useCallback(
        (item) => {
          // alert(JSON.stringify(item))
          if (appState?.[navbars] && Array.isArray(appState?.[navbars])) {
            const index = appState?.[navbars]?.findIndex(
              (res) => res.id == item?.id
            );
            appState[navbars][
              index >= 0 ? index : appState?.[navbars]?.length + 1
            ] = item;
          } else if (
            appState?.[navbars] &&
            typeof appState?.[navbars] == "object"
          ) {
            appState[navbars] = item;
          }
          delete appState?.navbars;
          delete appState?.section;
          delete appState?.editMode;
    
          // console.log('cccccc', 2222, navbars, appState?.[navbars])
          // return
          if (appState)
            saveDataDB({
              query: {
                date: moment(),
                config: appState,
                siteName: siteName
              },
              keys: ["siteName"],
              resource: "vare_sites",
            }).then((info) => {
              setEditItem({});
              setAppState((existing) => {
                return {
                  ...existing,
                  ...info?.[0]?.config,
                  editItemMain: {},
                  section: "",
                };
              });
              setLoading(false)
              // console.log('cccccc', info?.[0]?.config,)
            });
        },
        [navbars]
      );
    

    if (!navbars?.nav_links?.length) {
      return null;
    }
  

  return (<>
    <Navbar>
      <Logo>
        {navbars?.logo_desktop?.image && (
          <img src={navbars.logo_desktop.image} alt="Logo"
            style={{ height: navbars.logo_desktop?.height || 50 }} />
        )}
      </Logo>
  

      <Hamburger onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FiX /> : <FiMenu />}
      </Hamburger>

      <MenuLinks open={menuOpen}>
        {navbars.nav_links.map((item, idx) => (
          <NavLink key={idx}>
            <Link to={item.to} onClick={() => setMenuOpen(false)}>
              {item.label}
            </Link>
          </NavLink>
        ))}

{myInfo?.token && navEdit && 
   
   <NavLink 
   onClick={() => { 
    setAppState((prev) => ({
       ...prev,
       editMode: !editMode,
     }))
   }}>
     <CTAButton >Edit</CTAButton>
   </NavLink>
 }

        <NavLink>
          <CTAButton href="/calendar">Schedule a Consultation</CTAButton>
        </NavLink>

        <NavLink>
          <Link to={myInfo?.token ? "" : "/login"} onClick={handleLogout}>
            {myInfo?.token ? myInfo?.name : 'Login'}
          </Link>
        </NavLink>
      </MenuLinks>
    </Navbar>
        {editMode  && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: "row",
                          gap: 20,
                        }}
                      >
                        <NavLink
                          to="#"
                          className={editMode ? "btn-line" : "btn"}
                          id="btn-line"
                          onClick={() => {
                            setEditHeader(!editHeader)

                          }}
                          style={{
                            marginLeft: 100,
                            margin: 20,
                          }}
                        >
                          {"Edit"}
                        </NavLink>
    
                      
  
                        <div
                          // to="#"
                          className={"btn"}
                          id="btn-line"
                          // onClick={() => {
                          //   res?.onClick();
                          // }}
                          style={{
                            marginLeft: 100,
                            margin: 20,
                          }}
                        >
                          <div style={{
                            display: 'flex',
                            flexDirection: "row",
                            gap: 20,
                            zIndex: 99999,
                            alignItems: 'center'
                          }}>
                            <label
                              htmlFor="bgColor"
                              style={{
                                color: 'white',
                                // marginRight: '10px' 
                              }}>
                              Background Color:
                            </label>
                            <input
                              type="color"
                              id="bgColor"
                              onChange={handleColorChange}
                              value={newBgColor}
                            />
                            <label
                              htmlFor="textColor"
                              style={{
                                color: 'white',
                                // marginRight: '10px' 
                              }}>
                              Text Color:
                            </label>
                            <input
                              type="color"
                              id="textColor"
                              onChange={handleTextColor}
                              value={newTextColor}
                            />
                          </div>
    
                        </div>
    
                        <div style={{
                          color: 'white'
                        }}>{'header'}
                        </div>
                      </div>
                    )}

                    {editMode && editHeader && Object.keys(navbars)?.[0]
                            && (
                              <EditModal
                              item={navbars}
                              onSave={handleSave}
                              loading={false}
                              setLoading={()=>{}}
                              onClose={() => {
                                // setModalOpen(false);
                                // setEditItem({});
                
                                setAppState((existing) => {
                                  return {
                                    ...existing,
                                    modalOpen: false,
                                    editItemMain: {},
                                    section: "",
                                  };
                                });
                                setEditHeader(false)
                                // navigate('/')
                              }}
                            />
                            )}
  </>);
};

export default Nav;
